var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('div',{staticClass:"main"},[_c('p',[_vm._v("官网正在升级优化，请关注微信公众号查看最新咨询")]),_c('img',{attrs:{"src":require("../assets/logo-wx.jpg"),"alt":""}})])])
}]

export { render, staticRenderFns }